import * as React from 'react'
import * as ReactDOM from 'react-dom';
import { Editor, EditorChangeEvent, EditorTools } from '@progress/kendo-react-editor';
import * as BaseControls from './../common/BaseControls';
import * as Base from 'library'
import { ISystemBase } from 'library/types/ISystemBase';
import { SystemBase } from 'library/common/SystemBase';
import { EditorUtils } from "@progress/kendo-react-editor";

interface ISystemtextEditor  {
    insertText?: string,
    afterInsertText?():void
}

interface ISystemTextEditorState {
}

const {
    Bold, Italic, Underline, Strikethrough, Subscript, Superscript,
    AlignLeft, AlignCenter, AlignRight, AlignJustify,
    Indent, Outdent, OrderedList, UnorderedList,
    Undo, Redo, FontSize, FontName, FormatBlock,
    Link, Unlink, InsertImage, ViewHtml,
    InsertTable,
    AddRowBefore, AddRowAfter, AddColumnBefore, AddColumnAfter,
    DeleteRow, DeleteColumn, DeleteTable,
    MergeCells, SplitCell
} = EditorTools;

export default class SystemTextEditor extends SystemBase<ISystemtextEditor, ISystemTextEditorState>{
    editor: React.Ref<Editor>;

    constructor(props: any) {
        super(props);
        this.editor = React.createRef<Editor>();
    }

    // Author : Vivek Gupta
    // Description : for handling change event of editor, 
    // also removes <p> and </p> from the start and the end
    onChange = (event: EditorChangeEvent) => {
        var html = event.html;
        if (html) {
            var content = html.substring(3, html.length - 4);
            this.handleChange(event, content, content);
        } else this.handleChange(event, "", "");
    }

    // Author : Vivek Gupta
    // Description : checks any changes to insertText
    // Task Id : 15945 - Insert functinality
    componentDidUpdate = (prevProps:any) => {
        super.componentDidUpdate(prevProps);
        if (prevProps.insertText != this.props.insertText && this.props.insertText != '') {
            this.insertText(this.props.insertText)
        }
    }

    // Author : Vivek Gupta
    // Description : function to insert text at the current position in the Editor
    // Task Id : 15945 - Insert functinality
    insertText = (text?: string) => {
        if (!text) return;

        // get the current editor
        if (this.editor && this.editor.current) {
            let view = this.editor.current.view;
            // select the node
            const nodeType = view && view.state.schema.nodes['text'];
            // check whether we can insert text
            const canInsert = view && EditorUtils.canInsert(view.state, nodeType);
            // insert the text in the editor and raise event afterInsertText
            if (canInsert) {
                EditorUtils.insertNode(view, view.state.schema.text(text))
                this.props.afterInsertText && this.props.afterInsertText();
            }
        }
    }

    render() {

        // tools to be shown on the editor
        const tools = [
            [Bold, Italic, Underline, Strikethrough],
            [Subscript, Superscript],
            [AlignLeft, AlignCenter, AlignRight, AlignJustify],
            [Indent, Outdent],
            [OrderedList, UnorderedList],
            FontSize, FontName, FormatBlock,
            [Undo, Redo],
            [Link, Unlink, InsertImage, ViewHtml],
            [InsertTable],
            [AddRowBefore, AddRowAfter, AddColumnBefore, AddColumnAfter],
            [DeleteRow, DeleteColumn, DeleteTable],
            [MergeCells, SplitCell]
        ];

        return (
            <this.WrapperDiv>
                {this.props.isControlledMode
                    ? <Editor ref={this.editor} onChange={this.onChange} tools={tools} value={this.state.value as string | undefined}/>
                    : <Editor ref={this.editor} onChange={this.onChange} tools={tools} defaultContent={this.state.value as string | undefined}/>
                }
                </this.WrapperDiv>
        );
    }
}